import { LOCALES } from 'i18n/locales';

export const searchIntl = {
    [LOCALES.ENGLISH]: {
        'search.button': 'Search',
        'search.results': 'Search results',
        'search.noResults': 'No results found...',
        'search.error.unavailable': 'Service unavailable. Please try again',
        'search.error.charLength': 'Number of Characters must be between '
    },
    [LOCALES.WELSH]: {
        'search.button': 'Chwilio',
        'search.results': '[Search results]',
        'search.noResults': 'Ni chanfuwyd canlyniadau...',
        'search.error.unavailable': 'Gwasanaeth ddim ar gael. Rhowch gynnig arall arni',
        'search.error.charLength': 'Mae\'n rhaid i Nifer y Nodau fod rhwng '
    }
};
